exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert:after{content:\"\";display:table;clear:both}.alert{color:#fff;padding:10px;font-size:16px;line-height:1.25}.alert-error{background-color:#df3034}.alert-warning{background-color:#912b88}.alert-success,.alert-confirmation{background-color:#006435}.alert-success .icon-tick,.alert-confirmation .icon-tick{height:20px;width:20px;background-size:cover}.alert-message{color:#fff;display:table-cell;font-weight:bold}.alert-message a,.alert-message a:visited{color:#fff;text-decoration:underline}.alert .icon{display:table-cell;vertical-align:top}.alert .icon+.alert-message{padding-left:10px}", ""]);

// exports
